// src/pages/ConsolePage.tsx

import { useCallback, useState } from 'react';
import { RiMenuFold4Line, RiMenu3Line } from 'react-icons/ri';
import { useFabricService } from '../contexts/FabricServiceContext';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/button/Button';
import { MainLayout } from '../components/MainLayout';
import { SideDrawer } from '../components/SideDrawer';
import { Layout } from '../types/Layout';
import './ConsolePage.scss';

export function ConsolePage() {

  const { hasFabricServer } = useFabricService()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { usernameAvatar } = useAuth();

  const [layout, setLayout] = useState<Layout>(() => {
    const savedLayout = localStorage.getItem('tmp::fabric_layout');
    if (savedLayout) {
      return JSON.parse(savedLayout);
    }

    // Default layout
    return {
      size: 50,
      rows: 2,
      columns: 1,
      main: { widgetName: 'ChatDefaultWidget', size: 50 },
      grid: [
        {
          cells: [{ widgetName: 'PerceptionWidget', size: 100 }],
          size: 50
        },
        {
          cells: [{ widgetName: 'KnowledgeWidget', size: 100 }],
          size: 50
        }
      ]
    };
  });

  /**
   * Store Changes to layout
   */
  const handleLayoutChange = useCallback((newLayout: Layout) => {
    setLayout(newLayout);
    localStorage.setItem('tmp::fabric_layout', JSON.stringify(newLayout));
  }, []);

  /**
   * Side Drawer handler functions
   */
  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen(prev => !prev);
  }, []);

  /**
   * Render the application
   */

  return (
    <div data-component="ConsolePage" className={isDrawerOpen ? 'drawer-open' : ''}>
      <div className="content-top">
        <div className="content-title">
          <img src="/fabric-line-logo.svg" alt="Fabric Logo" />
          <span><b>fabric</b></span><span className='content-subtitle'>Human-Inspired AI</span>
        </div>
        <div className="content-top-row">
          {!hasFabricServer && <label>not connected</label>}
          {usernameAvatar()}
          <Button
            icon={isDrawerOpen ? RiMenuFold4Line : RiMenu3Line}
            buttonStyle="flush"
            onClick={toggleDrawer}
          />
        </div>
      </div>
      <MainLayout
        layout={layout}
        onLayoutChange={handleLayoutChange}
      />
      <SideDrawer
        isOpen={isDrawerOpen}
        eventFilterTypes={["append", "delta", "connection", "rate_limits"]}
        conversationFilterTypes={["tool_calls", "tool_responses"]}
        onLayoutChange={handleLayoutChange}
        currentLayout={layout}
      />
    </div>
  );
}
